// Add these to the English dashboard translations
export const enOrdersTranslations = {
	orders: {
		// Orders page
		title: 'Orders',
		subtitle: 'Manage and track all your restaurant orders',
		createManualOrder: 'Create Manual Order',
		orderDetails: 'Order Details',

		// Order table columns/headers
		orderId: 'Order ID',
		customer: 'Customer',
		items: 'Items',
		total: 'Total',
		status: 'Status',
		date: 'Date',
		viewDetails: 'View Details',
		amount: 'Amount',
		actions: 'Actions',
		orders: 'orders',

		// Order statuses
		statusPending: 'Pending',
		statusProcessing: 'Processing',
		statusCompleted: 'Completed',
		statusPreparing: 'Preparing',
		statusDelivered: 'Delivered',
		statusCancelled: 'Cancelled',
		updateStatus: 'Update Status',

		// Payment statuses and methods
		paymentStatus: 'Payment Status',
		paymentPending: 'Payment Pending',
		paid: 'Paid',
		refunded: 'Refunded',
		creditCard: 'Credit Card',
		cash: 'Cash',
		onlinePayment: 'Online Payment',

		// Filters and sorting
		filter: 'Filter',
		filterByStatus: 'Filter by Status',
		filterByDate: 'Filter by Date',
		sortBy: 'Sort By',
		dateRange: 'Date Range',
		startDate: 'Start Date',
		endDate: 'End Date',

		// Date filter options
		allTime: 'All Time',
		today: 'Today',
		yesterday: 'Yesterday',
		thisWeek: 'This Week',
		lastWeek: 'Last Week',
		thisMonth: 'This Month',
		lastMonth: 'Last Month',
		customRange: 'Custom Range',

		// Customer info
		customerInfo: 'Customer Information',

		// Delivery info
		deliveryInfo: 'Delivery Information',
		delivery: 'Delivery',
		pickup: 'Pickup',
		dineIn: 'Dine-in',
		deliveryAddress: 'Delivery Address',
		deliveryTime: 'Delivery Time',

		// Payment info
		paymentInfo: 'Payment Information',
		subtotal: 'Subtotal',
		tax: 'Tax',
		tip: 'Tip',
		discount: 'Discount',

		// Notes and actions
		notesAndActions: 'Notes & Actions',
		orderNotes: 'Order Notes',
		noNotes: 'No notes for this order',
		printOrder: 'Print Order',
		generateInvoice: 'Generate Invoice',
		contactCustomer: 'Contact Customer',

		// Error states
		orderNotFound: 'Order Not Found',
		orderNotFoundDescription: 'The order you are looking for does not exist or has been removed.',
		noOrdersMatchingFilters: 'No orders match your filters',
		noOrdersYet: 'No orders yet',

		ordersOverTime: 'Orders Over Time',
		totalOrders: 'Total Orders',
		revenue: 'Revenue',
	},
};